import { useNavigate } from 'react-router-dom'
import { ICellRendererParams } from '@ag-grid-community/core'
import { Button } from 'components/common'
import { UserEditIcon } from 'components/icons'
import { PAGE_UPDATE_USER } from 'utils/constants'

type Props = {
  params: ICellRendererParams
  isEditor: boolean
}

const EditButtonCellRenderer = ({ params, isEditor }: Props) => {
  const navigate = useNavigate()

  const handleEditUser = () => {
    if (isEditor) {
      navigate(`${PAGE_UPDATE_USER.path}/${params.data._id}`)
    }
  }

  return (
    <div>
      <Button
        size="small"
        icon={<UserEditIcon />}
        type="button"
        variant="outline"
        onClick={handleEditUser}
      />
    </div>
  )
}

export default EditButtonCellRenderer
